import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const AdornmentContainer = styled.div`
  color: var(--adornment-color);
  // we've got hardcoded 'relative' classNames in kds Button component
  // messing up with z-indexes and breaking the Table layout.
  // We can remove this in future once Table Layout is refactored.
  & button {
    position: static;
    & > span {
      position: static;
    }
  }
`;

export const AdornmentWrapper = styled.div`
  ${({ hasAdornments, translateYValue }) => {
    if (hasAdornments) {
      return css`
        display: flex;
        align-items: center;
        ${translateYValue && `transform: translateY(${translateYValue});`}
      `;
    } else {
      return '';
    }
  }}
`;
// centering adornments case by case to be compatable with legacy kizen typography
export const Adornments = styled.div`
  padding-left: 15px;
  display: flex;
  gap: 10px;
  ${({ variant }) => {
    if (variant === 'outline') {
      return css`
        padding-left: 0px;
      `;
    }
    if (variant === 'underline') {
      return css`
        padding-left: 0px;
        transform: translateY(-3px);
      `;
    }
    if (variant === 'client-card') {
      return css`
        padding-left: 10px;
        transform: translateY(-1px);
      `;
    }

    if (variant === 'inline') {
      return css`
        padding-left: 5px;
        transform: translateY(2px);
      `;
    }
  }}
`;
